var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"game__stream"},[_c('div',{staticClass:"game__stream__player"},[_c('iframe',{attrs:{"src":_vm.getUrlVimeoPlayer(),"frameborder":"0","allow":"autoplay;"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }